const sortById = (a, b) => {
  const aa = a?.id;
  const bb = b?.id;

  return aa < bb ? -1 : aa > bb ? 1 : 0;
};

export default sortById;
